import type { File, Folder } from '@efdigital/ll-addon-data';
import { Heading } from '@efdigital/ll-addon-ui';
import FileBrowser from '@efdigital/ll-admin-v2/components/files/file-browser.gts';
import FileUploader from '@efdigital/ll-admin-v2/components/files/file-uploader.gts';
import { on } from '@ember/modifier';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import BsModal from 'ember-bootstrap/components/bs-modal';

export default class LibraryFoldersIndex extends Component {
  @service declare router: RouterService;

  @tracked currentPath: string = '|';
  @tracked isFileModalOpen = false;
  @tracked isFolderModalOpen = false;

  onFileSelected = (file: File) => {
    this.router.transitionTo('library.folders.file', file.id!);
    return Promise.resolve();
  };

  navigateToFolder = (path: string) => {
    this.currentPath = path;
  };

  onFolderSelected = (folder: Folder) => {
    this.currentPath = folder.id!;
  };

  showFileModal = () => {
    this.isFileModalOpen = true;
  };

  hideFileModal = () => {
    this.isFileModalOpen = false;
  };

  showFolderModal = () => {
    this.isFolderModalOpen = true;
  };

  hideFolderModal = () => {
    this.isFolderModalOpen = false;
  };

  fileUploaded = (file: File) => {
    this.isFileModalOpen = false;
    this.currentPath = file.parent;
  };

  <template>
    <div class="container py-5">
      <Heading
        @text="Private Files"
        @secondary="Store documents securely. These folders can be embedded within pages."
      />

      <FileBrowser
        @path={{this.currentPath}}
        @navigateToFolder={{this.navigateToFolder}}
        @selectFile={{this.onFileSelected}}
        @selectFolder={{this.onFolderSelected}}
      />

      <div class="text-center mt-5">
        <button
          type="button"
          class="btn btn-primary btn-lg"
          {{on "click" this.showFileModal}}
        >
          <iconify-icon inline icon="ph:file-plus" />
          Add File
        </button>

        <button
          type="button"
          class="btn btn-primary btn-lg"
          {{on "click" this.showFolderModal}}
        >
          <iconify-icon inline icon="ph:folder-plus" />
          Add Folder
        </button>
      </div>

      <BsModal
        @open={{this.isFileModalOpen}}
        @onHidden={{this.hideFileModal}}
        @size="xl"
        @backdropClose={{false}}
        as |modal|
      >
        <modal.header>
          <h2 class="modal-title fs-5">Add File</h2>
        </modal.header>
        <modal.body>
          <FileUploader
            @parentFolderId={{this.currentPath}}
            @onFileUploaded={{this.fileUploaded}}
          />
        </modal.body>
      </BsModal>

      <BsModal
        @open={{this.isFolderModalOpen}}
        @onHidden={{this.hideFolderModal}}
        @size="xl"
        @backdropClose={{false}}
        as |modal|
      >
        <modal.header>
          <h2 class="modal-title fs-5">Add Folder</h2>
        </modal.header>
        <modal.body>
          {{! TODO: Add folder }}
        </modal.body>
      </BsModal>
    </div>
  </template>
}
